<template>
  <div class="analysis-box">
    <div class="analysis-box-title flex-box flex-between flex-items">
      <span>事故类型分析</span>
      <!-- <el-select v-model="timeType" placeholder="请选择">
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select> -->
    </div>
    <div class="analysis-box-content" v-if="tableData.length > 0">
      <div
        class="analysis-box-content-item"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <div class="analysis-box-content-label">{{ item.dangerType }}</div>
        <div class="analysis-box-content-f">
          <div class="analysis-box-content-text flex-box">
            <div class="analysis-box-content-text-box">
              <div class="analysis-box-content-text-box-num">
                {{ item.accidentAmount }}
              </div>
              <div class="analysis-box-content-text-box-t">金额（元）</div>
            </div>
            <div class="analysis-box-content-text-box">
              <div class="analysis-box-content-text-box-num">
                {{ item.accidentTimes }}
              </div>
              <div class="analysis-box-content-text-box-t">次数（次）</div>
            </div>
          </div>
          <el-progress
            :percentage="item.typeRate"
            :stroke-width="15"
            :color="['#2890EB', '#6EBAFE']"
          ></el-progress>
        </div>
      </div>
    </div>
    <div v-else class="tips">暂无数据</div>
  </div>
</template>

<script>
import Chart from "@/components/Chart/Charts";
export default {
  components: { Chart },
  props: {
    details: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    details: {
      handler(v) {
        this.tableData = v.caseAnalysisData.caseAnalysisList;
      },
    },
  },
  data() {
    return {
      timeType: "",
      timeOptions: [
        {
          label: "本周",
          value: 1,
        },
      ],
      gaugeOptions: {},
      dataGather: {
        nonono: 2222,
      },
      tableData: [],
    };
  },
  created() {
    this.$nextTick(() => {
      this.gaugeOptions = {};
    });
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-progress__text {
  font-weight: bold;
}
::v-deep .el-progress-bar {
  padding-right: 85px;
  margin-right: -85px;
}
.analysis-box {
  padding: 16px 24px;
  margin-bottom: 10px;
  background: #ffffff;
  border-radius: 4px;
  &-title {
    position: relative;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 24px;
  }
  &-title::before {
    content: "";
    position: absolute;
    left: -24px;
    top: 0;
    bottom: 0;
    width: 6px;
    background: #4278c9;
  }
  &-content {
    overflow: auto;
    max-height: 310px;
    &-label {
      width: 60px;
    }
    &-item {
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333333;
      margin-bottom: 24px;
    }
    &-f {
      flex: 1;
      margin-left: 10px;
    }
    &-text {
      justify-content: right;
      padding-right: 85px;
      &-box {
        margin-left: 36px;
        &-num {
          font-size: 18px;
          font-weight: bold;
          color: #333333;
          margin-bottom: 8px;
        }
        &-t {
          margin-bottom: 8px;
        }
      }
    }
  }
}
.flex-box {
  display: flex;
}
.flex-between {
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.flex-items {
  align-items: center;
}
.items-end {
  align-items: flex-end;
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.flex-4 {
  flex: 4;
}
.flex-5 {
  flex: 5;
}
.flex-6 {
  flex: 6;
}
.flex-7 {
  flex: 7;
}
.margin-r {
  margin-right: 10px;
}
.margin-l {
  margin-left: 10px;
}
.color-b {
  color: #0080ff;
}
.text-underline {
  text-decoration: underline;
}
.pointer {
  cursor: pointer;
}
.tips {
  line-height: 300px;
  text-align: center;
  color: #909399;
}
</style>
